// extracted by mini-css-extract-plugin
export default {"container":"GrapeGame_container__tnd9U","gameContainer":"GrapeGame_gameContainer__qLI3C"};